import React from 'react'
import {useStateValue} from './StateProvider'
import './Product.css'

function Product({title,price,rating,image}) {
    const[{basket},dispatch]=useStateValue()

    console.log(basket)
    const addToBasket=()=>{
        dispatch({
            type:"ADD_TO_BASKET",
            item:{
                title:title,
                price:price,
                rating:rating,
                image:image
            }
        })
    }
    
    return (
        <div className="product">
            <div className="product__info">
                <p>{title}</p>
                <p className="product__price">
                    <small>$</small>
                    <strong>{price}</strong>
                </p>
                <div className="product__rating">
                    {Array(rating).fill().map((_,i)=>
                        <p>⭐</p>
                    )}
                </div>
            </div>
                <img src={image} alt=""></img>

                <button onClick={addToBasket}>Add to basket</button>
        </div>
    )
}

export default Product
